import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../guards/authenticated.guard';
import { ShareContactInfoPageComponent } from './share-contact-info.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: ShareContactInfoPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ShareContactInfoPageRoutingModule {}
